<template>
	<div>
		<el-container >
			<el-aside width="250px">
				<LocationTree @getTreeData="locationTreeNodeClick"/>
			</el-aside>

			<el-container>
				<el-header >
					<el-form :inline="true" >
						<el-form-item>
							<el-input
									v-model="searchForm.code"
									placeholder="人员号"
									clearable
									style="display: block; width: 150px;"
							>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-input
									v-model="searchForm.name"
									placeholder="姓名"
									clearable
									style="display: block; width: 150px;"
							>
							</el-input>
						</el-form-item>

						<el-form-item>
							<el-select v-model="taskFlagValue" placeholder="请选择" style="display: block; width: 120px;">
								<el-option
								v-for="item in taskFlagOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item>
							<el-select v-model="sendFlagValue" placeholder="请选择" style="display: block; width: 100px;">
								<el-option
								v-for="item in sendFlagOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="日期范围" label-width="100px">
							<el-date-picker 
								v-model="queryDate" 
								type="daterange" 
								value-format="yyyy-MM-dd"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期">
							</el-date-picker>
						</el-form-item>

						<el-form-item>
							<el-button @click="getMachineTaskList">搜索</el-button>
						</el-form-item>

						<!-- <el-form-item>
							<el-button type="primary" @click="addMachineList">添加</el-button>
						</el-form-item>

						<el-form-item>
							<el-popconfirm title="这是确定批量删除吗？" @confirm="delHandle(null)">
								<el-button type="danger" slot="reference" :disabled="delBtlStatu">批量删除</el-button>
							</el-popconfirm>
						</el-form-item> -->

						<!-- <el-form-item>
							<el-popconfirm title="确定重新下传（卡片\密码\指纹）吗？" @confirm="delHandle(null)">
								<el-button type="primary" slot="reference" :disabled="delBtlStatu">重新下传</el-button>
							</el-popconfirm>
						</el-form-item> -->
					</el-form>
				</el-header>

				<el-main>
					<el-table
							ref="multipleTable"
							:data="tableData"
							tooltip-effect="dark"
							style="width: 100%; margin-top: -20px;"
							:height="tableHeight"
							:row-style="{height: '0px'}"
							:cell-style="{padding: '2px'}"
							:header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
							border
							stripe
							@selection-change="handleSelectionChange">

						<el-table-column
								type="selection"
								width="55">
						</el-table-column>

						<el-table-column
								prop="personNo"
								label="人员号"
								width="100">
						</el-table-column>

						<el-table-column
								prop="personName"
								label="姓名"
								width="100">
						</el-table-column>

						<el-table-column
								prop="taskContent"
								label="下传内容"
								width="100"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="locationFullName"
								label="位置"
								width="180"
								show-overflow-tooltip>
						</el-table-column>
						
						<el-table-column
								prop="machineNum"
								label="设备编号"
								width="130"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="machineNo"
								label="机号"
								width="80"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="taskFlag"
								label="名单类型"
								width="100">
							<template slot-scope="scope">
								<el-tag size="small" v-if="scope.row.taskFlag === 0" type="success">远程开门</el-tag>
								<el-tag size="small" v-else-if="scope.row.taskFlag === 1" type="primary">下传卡片</el-tag>
								<el-tag size="small" v-else-if="scope.row.taskFlag === 2" type="danger">下传密码</el-tag>
								<el-tag size="small" v-else-if="scope.row.taskFlag === 3" type="warning">下传指纹</el-tag>
								<el-tag size="small" v-else-if="scope.row.taskFlag === 4" type="primary">删除卡片</el-tag>
								<el-tag size="small" v-else-if="scope.row.taskFlag === 5" type="danger">删除密码</el-tag>
								<el-tag size="small" v-else-if="scope.row.taskFlag === 6" type="warning">删除指纹</el-tag>
								<el-tag size="small" v-else-if="scope.row.taskFlag === 7" type="warning">网关重启</el-tag>
							</template>
						</el-table-column>

						<el-table-column
								prop="taskType"
								label="名单属性"
								width="100">
							<template slot-scope="scope">
								<el-tag size="small" v-if="scope.row.taskType === 0" type="success">无</el-tag>
								<el-tag size="small" v-else-if="scope.row.taskType === 1" type="danger">IC卡</el-tag>
								<el-tag size="small" v-else-if="scope.row.taskType === 2" type="danger">身份证</el-tag>
								<el-tag size="small" v-else-if="scope.row.taskType === 3" type="danger">单次密码</el-tag>
								<el-tag size="small" v-else-if="scope.row.taskType === 4" type="danger">固定密码</el-tag>
							</template>
						</el-table-column>

						<el-table-column
								prop="downloadFlag"
								label="下传状态"
								width="100">
							<template slot-scope="scope">
								<el-tag size="small" v-if="scope.row.downloadFlag === 1" type="success">已下传</el-tag>
								<el-tag size="small" v-else-if="scope.row.downloadFlag === 0" type="danger">未下传</el-tag>
							</template>

						</el-table-column>

						<el-table-column
								prop="downloadTime"
								label="下传时间"
								width="180"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="beginTime"
								label="开始日期"
								width="100"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="endTime"
								label="结束日期"
								width="100"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="createTime"
								label="生成时间"
								width="180"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
							prop="icon"
							fixed="right"
							label="操作">
							<template slot-scope="scope">

							  <el-button type="text" @click="reSendHandle(scope.row.id)">下传</el-button>
							</template>

						 </el-table-column>
					</el-table>

					<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							layout="total, sizes, prev, pager, next, jumper"
							:page-sizes="[10, 20, 50, 100, 500, 1000]"
							:current-page="current"
							:page-size="size"
							:total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

	</div>
</template>

<script>
import DeptTree from '../base/DeptTree.vue'
	import LocationTree from "../base/LocationTree.vue"
	export default {
		name: "MachineTask",
		components:{LocationTree, DeptTree},
		data() {
			return {
				searchForm: {},
				searchPersonForm: {},
				delBtlStatu: true,

				total: 0,
				size: 10,
				current: 1,

				dialogVisible: false,
				editForm: {
					beginDate: '',
					endDate: ''
				},
				locationForm: {

				},

				tableData: [],
				personData: [],
				machineData: [],

				selectedMachineId:'',
				selectedMachineInfo:'',
				treeSelectLocationId: 0,

				editFormRules: {
					validDate: [
						{required: true, message: '请选择有效日期范围', trigger: 'blur'}
					]
				},

				multipleSelection: [],
				multiplePersonSelection: [],
				multipleMachineSelection: [],

				permDialogVisible: false,
				permForm: {},
				defaultProps: {
					children: 'children',
					label: 'personName'
				},
				permTreeData: [],
				treeSelectDeptId: 0,
				validDate: [],
				taskFlagOptions: [{
					value: '0',
					label: '全部'
					}, {
					value: '1',
					label: '远程开门'
					}, {
					value: '2',
					label: '下传卡片'
					}, {
					value: '3',
					label: '下传密码'
					}, {
					value: '4',
					label: '下传指纹'
					}, {
					value: '5',
					label: '删除卡片'
					}, {
					value: '6',
					label: '删除密码'
					}, {
					value: '6',
					label: '删除指纹'
					}],
				taskFlagValue: '0',
				sendFlagOptions: [{
					value: '0',
					label: '全部'
					}, {
					value: '1',
					label: '未下传'
					}, {
					value: '2',
					label: '已下传'
					}],
				
				sendFlagValue: '0',
				queryDate: ''
			}
		},
		computed: {
			tableHeight: function() {
				return screen.height > 900 ? 630: 550
			},
			listHeight: function() {
				return screen.height > 900 ? 646: 566
			}
		},
		created() {
			this.defaultDate();
			this.getMachineTaskList();
			// this.getMachineTaskList()
			// this.$axios.get('/base/person/list').then(res => {
			// 	this.permTreeData = res.data.data
			// })

			this.treeSelectLocationId = 0;
			this.getMachineTaskList();
		},
		methods: {
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				console.log("勾选")
				console.log(val)
				this.multipleSelection = val;

				this.delBtlStatu = val.length == 0
			},
			handleMachineSelectionChange(val) {
				console.log("勾选设备")
				console.log(val)
				this.multipleMachineSelection = val;
			},
			machineRowClick(row) {
				console.log('row', row);
				this.selectedMachineId = row.id;
				// this.getMachineTaskList();
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.size = val
				this.getMachineTaskList()
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.current = val
				this.getMachineTaskList()
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false
				this.editForm = {}
			},
			handleClose() {
				this.resetForm('editForm')
			},

			locationTreeNodeClick(locationdata) {
				this.treeSelectLocationId = locationdata.id;
				this.getMachineTaskList();
			},

			getMachineTaskList() {

				var selMachineIds = []

				this.multipleMachineSelection.forEach(row => {
					selMachineIds.push(row.id)
				})

				console.log('查询设备[' + selMachineIds + ']');

				this.$axios.get("/iot/machinetask/list", {
					params: {
						personNo: this.searchForm.code,
						personName: this.searchForm.name,
						locationId: this.treeSelectLocationId,
						taskFlag: this.taskFlagValue,
						sendFlag: this.sendFlagValue,
						beginDate: this.queryDate[0],
						endDate: this.queryDate[1],
						current: this.current,
						size: this.size
					}
				}).then(res => {
					this.tableData = res.data.data.records
					this.size = res.data.data.size
					this.current = res.data.data.current
					this.total = res.data.data.total
				})
			},

			getMachineList() {
				this.$axios.get("/iot/machine/list", {
					params: {
						name: "",
						locationId: this.locationForm.locationId,
						current: this.current,
						size: this.size
					}
				}).then(res => {
					this.machineData = res.data.data.records
					this.size = res.data.data.size
					this.current = res.data.data.current
					this.total = res.data.data.total
				})
			},
			addMachineList() {
				//添加设备名单
				if (this.selectedMachineId === '') {
					this.$message({
						showClose: true,
						message: '请先选择设备',
						type: 'warning',
						onClose:() => {
							this.getMachineTaskList()
						}
					});
				} else {
					this.dialogVisible = true
				}

			},
			reSendHandle(id) {
				//重新下传
				this.$axios.post("/iot/machinetask/resend/" + id).then(res => {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
						onClose:() => {
							this.getMachineTaskList()
						}
					});
				})
			},
			tableRowStyleName ({row}) {
				if (this.selectedMachineId == row.id) {
					return 'background-color: #E0E0E0 !important;';
				}
			},
			defaultDate(){
				//获取当前时间
				let date = new Date()
				//获取当前时间的年份转为字符串
				let year = date.getFullYear().toString() 
				//获取月份，由于月份从0开始，此处要加1，判断是否小于10，如果是在字符串前面拼接'0'
				let month = date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1).toString():(date.getMonth()+1).toString() 
				//获取天，判断是否小于10，如果是在字符串前面拼接'0'
				let da = date.getDate() < 10 ? '0'+date.getDate().toString():date.getDate().toString() 
				//字符串拼接，开始时间，结束时间
				let nowDate = year + '-' + month + '-' + da
				//将值设置给插件绑定的数据
				this.queryDate = [nowDate, nowDate] 
				// console.log("queryDate111", this.queryDate)

			}
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}
	.el-select {
		width: 100%;
	}
	.el-table .warning-row {
		background: pink!important;
	}
</style>